import { SegmentGroup } from "@chakra-ui/react-v3";

type LabelFilterSegmentedControlProps<T extends string> = {
  value: T;
  items: { value: T; label: string; indicatorColor?: string }[];
  onValueChange: (value: T) => void;
};

/**
 * Generic segmented control for filtering by labels.
 * Single-select control where each item can optionally specify an indicator color.
 *
 * NOTE: Use a color with alpha set to 0.4 for the indicator to retain glass effect.
 */
export function LabelFilterSegmentedControl<T extends string>({
  value,
  items,
  onValueChange,
}: LabelFilterSegmentedControlProps<T>) {
  const indicatorColor = items.find(item => item.value === value)?.indicatorColor;

  return (
    <SegmentGroup.Root
      size="sm"
      value={value}
      onValueChange={(details: { value: T }) => onValueChange(details.value)}
      bg="bg.surface"
      display="flex"
      alignItems="center"
    >
      <SegmentGroup.Indicator
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: 'bg' prop should be found in SegmentGroupIndicatorProps but its not
        bg={indicatorColor}
        style={{ transition: "all 0.15s ease" }}
        height="100%"
      />
      <SegmentGroup.Items
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: 'bg' prop should be found in SegmentGroupIndicatorProps but its not
        cursor="pointer"
        height="100%"
        items={items.map(item => ({
          value: item.value,
          label: item.label,
        }))}
      />
    </SegmentGroup.Root>
  );
}
